
export enum UserRoles {
  //ROLES FOR VIEW
  ROLE_VIEW_READONLY = 'view.readonly',
  ROLE_VIEW_BOUTIQUE = 'view.boutique',
  ROLE_VIEW_COMMUNITY_SHOP = 'view.community_shop',
  ROLE_VIEW_PROMOTIONS = 'view.promotions',
  ROLE_VIEW_ITEMS = 'view.items',
  ROLE_VIEW_ITEMS_PERMANENTS = 'view.items.permanents',


  //ROLES FOR MANAGE
  ROLE_MANAGE_ADMIN = 'manage.admin',
  ROLE_MANAGE_PARTNER = 'manage.partner'

}
